import React from 'react';


/**
 * Solicita permissão do usuário para exibir notificações no navegador.
 *
 * Este método verifica se a API de Notification está disponível. Caso não esteja,
 * retorna imediatamente 'denied'. Se estiver disponível, exibe o prompt de permissão
 * e retorna uma Promise que resolve com o resultado da permissão.
 *
 * A Promise resolve com uma das seguintes strings:
 * - 'granted'  → o usuário permitiu notificações
 * - 'denied'   → o usuário negou notificações ou o navegador não suporta
 * - 'default'  → o usuário não respondeu ao prompt (timeout de 10s) ou fechou o prompt
 *
 * Comportamento adicional:
 * - Se o usuário responder **após o timeout de 10 segundos** com 'granted' ou 'denied',
 *   a página é recarregada para aplicar a configuração.
 * - Em caso de erro ao solicitar permissão, a Promise é rejeitada com uma Error.
 *
 * @returns {Promise<string>} Promise que resolve com 'granted', 'denied' ou 'default'
 */
export default async function askNotificationPermission(): Promise<string> {
  // Check if the browser supports notifications
  if (!('Notification' in window)) {
    // console.log('This browser does not support notifications.');
    return 'denied';
  }

  return new Promise((resolve, reject) => {
    let timedOut = false;

    const timeout = setTimeout(() => {
      // console.log('timed out');
      resolve('default');
      timedOut = true;
    }, 10000);

    Notification.requestPermission()
      .then((permission) => {
        // console.log(permission);
        resolve(permission);

        if (timedOut && permission !== 'default') {
          window.location.reload();
        }
      })
      .catch(() => {
        // console.log('Permission request failed:', error);
        reject(
          new Error('Falha ao solicitar permissão para exibir notificação'),
        );
      })
      .finally(() => clearTimeout(timeout));
  });

  // O usuário ainda não definiu se é para permitir as notificações, solicitamos a permissão
  /* if (Notification.permission === 'default') {
    try {
      const permission = await Notification.requestPermission();

      return permission === 'granted';
    } catch (err) {
      alert('Erro ao solicitar permissão de notificação');
    }
  }

  return false; */
}
